/**
 * 從 caption 物件中移除指定 index，並把後面的鍵往前位移一格。
 *
 * @param {Object} captions   - key 為 numeric index 字串，value 為 caption 字串
 * @param {number} deletedIndex
 * @returns {Object} 新的 caption 物件
 */
export const reindexCaptionsAfterDelete = (captions, deletedIndex) => {
  const result = {};
  Object.entries(captions).forEach(([key, value]) => {
    const k = Number(key);
    if (k < deletedIndex) result[k] = value;
    else if (k > deletedIndex) result[k - 1] = value;
  });
  return result;
};
